export const fallbackProducts = [
  {
    id: "p7",
    name: "Height Bal Capsules",
    category: "Growth Support",
    tagline: "Ayurvedic support for natural growth and posture.",
    description:
      "A classical formula supporting body balance, nourishment, and strength with herbs aimed at growth and structural wellness.",
    price: "₹699",
    image: "/products/height-bal-capsules.jpg",
  },
  {
    id: "p8",
    name: "Ranjana Capsule",
    category: "Women’s Wellness",
    tagline: "Gentle herbal balance for women’s monthly health.",
    description:
      "A carefully blended capsule for reproductive wellness, hormonal support, and internal calm rooted in Ayurvedic tradition.",
    price: "₹649",
    image: "/products/ranjana-capsule.jpg",
  },
  {
    id: "p9",
    name: "No More Weakness Capsule",
    category: "Vitality",
    tagline: "Strength and endurance in a daily herbal capsule.",
    description:
      "A potent blend designed to restore energy, reduce fatigue, and support resilience with nourishing herbs for everyday strength.",
    price: "₹579",
    image: "/products/no-more-weakness-capsule.jpg",
  },
  {
    id: "p10",
    name: "Super X Capsule",
    category: "Performance Care",
    tagline: "Powerful support for stamina and wellbeing.",
    description:
      "An intensive herbal formula that helps maintain energy, muscle comfort, and vitality for active bodies.",
    price: "₹749",
    image: "/products/super-x-capsule.jpg",
  },
  {
    id: "p11",
    name: "Ranjana Jeevan Amrit",
    category: "Daily Tonics",
    tagline: "A nourishing elixir for inner strength.",
    description:
      "A nourishing 30ml tonic crafted from traditional herbs to boost vitality, digestion, and daily balance in one gentle dose.",
    price: "₹499",
    image: "/products/ranjana-jeevan-amrit.jpg",
  },
  {
    id: "p12",
    name: "Ranjana Immune Gold Drop",
    category: "Immunity",
    tagline: "A golden boost for natural defenses.",
    description:
      "A targeted immune support drop with herbs to strengthen defenses, soothe inflammation, and help the body stay resilient.",
    price: "₹549",
    image: "/products/ranjana-immune-gold-drop.jpg",
  },
];

export const fallbackTestimonials = [
  {
    id: "t1",
    name: "Asha",
    location: "Rishikesh",
    concern: "Sleep & stress",
    quote:
      "The quiet evenings after a week of the ritual feel like I finally learned how to breathe again.",
    rating: 5,
  },
  {
    id: "t2",
    name: "Neel",
    location: "Bengaluru",
    concern: "Digestive care",
    quote:
      "Small changes, grounded in tradition, that actually helped me feel lighter and more steady.",
    rating: 5,
  },
  {
    id: "t3",
    name: "Priya",
    location: "London",
    concern: "Immunity",
    quote:
      "I appreciate that the remedies feel honest, simple, and easy to keep doing every day.",
    rating: 4,
  },
];
